import { atom } from "recoil";

export const PolygonAreaState = atom({
  key: "PolygonAreaState",
  default: {
    district: [],
    subDistrict: [],
    isLoading: false,
  },
});
